import React from "react";
import { SearchTypeEnum, ISearchValue } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { usePaymentModel } from "../paymentModel";
import { useGlobalModel } from "@/model/globalModel";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData,
    } = usePaymentModel();
    const { fetchWarehouseList, shopDs } = useGlobalModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            placeholder: "从属门店",
            fieldName: "shopCode",
            options: shopDs.map(item => ({ ...item, value: item.code }))
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "账户编码",
            fieldName: "code",
            size: "small",
        },
    ]

    return (
        <YhPageHeader
            title="异常挂账"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}